import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import PromiseContainer from '../../../components/data/PromiseContainer';
import { Page } from '../../../components/surfaces';
import { useStore } from '../../../store';
import usePromise from '../../../store/utils/usePromise';
import ProductForm from './components/ProductForm';

export default observer(function EditProductPage() {
  const { productId = '' } = useParams();
  const { productStore } = useStore();

  const [productPromise] = usePromise(
    () => productStore.fetchProduct(productId),
    [productId],
  );

  return (
    <Page navigation={productPromise.value?.displayName || '…'}>
      <PromiseContainer promise={productPromise}>
        {(value) => <ProductForm product={value} />}
      </PromiseContainer>
    </Page>
  );
});
